import { Discount, DiscountEarlyBird } from '../../types/DiscountTypes'
import {
  fixMathRounding,
  getActivitiesWithDiscountId,
  getPriceFromCalculation,
  getBasePriceFromCalculation
} from './CalculateDiscountHelpers'
import {
  CalculateDiscountLogic,
  Calculation,
  CalculationDiscount,
  CalculationUserInput,
  DiscountType
} from './CalculateDiscountTypes'

export class EarlyBirdDiscountLogic implements CalculateDiscountLogic {
  type: DiscountType = 'early_bird'
  discountDefinition: DiscountEarlyBird

  constructor(discount: Discount) {
    this.discountDefinition = discount as DiscountEarlyBird
  }

  chooseEligible(previousCalculations: Calculation[], userInput: CalculationUserInput) {
    return getActivitiesWithDiscountId(previousCalculations, this.discountDefinition.id)
  }

  private isWithinEarlyBirdPeriod(): boolean {
    const deadline = new Date(this.discountDefinition.earlyBirdDeadline)
    const today = new Date()
    // Set time to 00:00:00 for both to compare only the date
    deadline.setHours(0, 0, 0, 0)
    today.setHours(0, 0, 0, 0)
    return today <= deadline
  }

  calculate(previousCalculations: Calculation[], userInput: CalculationUserInput) {
    const eligibleActivities = this.chooseEligible(previousCalculations, userInput)

    previousCalculations.map((calculation) => {
      if (!eligibleActivities.includes(calculation.activity.id)) return
      // Check if today is before or on the early bird deadline
      if (!this.isWithinEarlyBirdPeriod()) return
      const activityPrice = getPriceFromCalculation(calculation)
      const basePrice = getBasePriceFromCalculation(calculation)
      const discountAmount =
        this.discountDefinition.calculationType === 'amount'
          ? this.discountDefinition.value // amount discount
          : fixMathRounding(basePrice * (this.discountDefinition.value / 100)) // percentage discount on base price

      const earlyBirdDiscount: CalculationDiscount = {
        type: this.type,
        name: this.discountDefinition.name,
        id: this.discountDefinition.id,
        input: activityPrice,
        discount: discountAmount,
        output: fixMathRounding(activityPrice - discountAmount),
        discountCalculationType: this.discountDefinition.calculationType,
        discountValue: this.discountDefinition.value,
        discountGroup: this.discountDefinition.discountGroup
      }

      calculation.discounts = calculation.discounts || []
      calculation.discounts.push(earlyBirdDiscount)
      calculation.finalPrice = earlyBirdDiscount.output
    })

    return previousCalculations
  }
}
